import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { ETLView } from '../../containers/account/integrations/ETLView';

export const AdminAccountIntegrationsPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<ETLView />
		</AdminDashboardPageLayout>
	);
};
